import compraDireta from './CompraDiretaApiClient'
import produto from './ProdutoApiClient'
import validarDocumentoApi from './ValidacaoDocumentoApiClient'
import arquivoApi from '@/core/apiclient/ArquivoApi'
import usuario from './UsuarioApiClient'

export default {
    compraDireta,
    produto,
    validarDocumentoApi,
    arquivoApi,
    usuario
}
